<template>
  <div class="mop-datatable">
    <div class="table-header mb-3">
      <div class="flex flex-wrap gap-2 items-center justify-between">
        <div class="flex items-center gap-2">
          <MOPButton v-if="clearShow" :label="isMobile ? '' : 'Clear'" icon="pi pi-filter-slash" :iconPos="isMobile ? undefined : 'right'" @click="clearFilter" severity="secondary" />
          <MOPButton v-if="bulkimport" :label="isMobile ? '' : 'Bulk Import'" icon="pi pi-file-excel" :iconPos="isMobile ? undefined : 'right'" @click="triggerFileInput" severity="info" />
          <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" style="display: none" />
          <slot name="table-actions1"></slot>
        </div>
        <div class="flex">

          <!-- <MOPButton v-if="importshow" label="Excel Import" class="me-3" icon="pi pi-file-excel" iconPos="right" @click="triggerFileInput"/> -->

          <MOPButton v-if="bulkimport" label="Bulk Import" class="me-3" icon="pi pi-file-excel" iconPos="right"
            @click="triggerFileInput" />


          <!-- <MOPButton label=" Excel Import" class="me-3" icon="pi pi-file-excel" iconPos="right" @click="triggerFileInput"/> -->

          <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" style="display: none" />
          <slot name="table-actions1"></slot>
          <MOPInputIcon icon="pi pi-search" v-model="globalFilterValue" placeholder="Search..."
            @input="debouncedOnGlobalFilter" />

          <!-- Slot for additional buttons/menus -->
          <slot name="table-actions"></slot>

          <MOPButton v-if="exportStatus == 0" class="ms-3" icon="pi pi-download" severity="secondary" @click="toggle" />
          <MOPMenu ref="menu" id="overlay_menu" :model="items" :popup="true" />
        </div>
      </div>
    </div>

    <!-- Mobile Card View -->
    <div v-if="showMobileCards" class="mop-mobile-cards">
      <!-- Mobile skeleton loading -->
      <MOPCardSkeleton v-if="props.loading" :rows="props.rows || 5" />

      <!-- Mobile card list -->
      <template v-else>
        <div v-if="!props.value || props.value.length === 0" class="text-center py-8 text-gray-500">
          <i class="pi pi-inbox text-4xl mb-3 block text-gray-300"></i>
          <p class="text-sm">No records found</p>
        </div>

        <div v-else class="space-y-3">
          <div
            v-for="(row, rowIndex) in mobilePagedData"
            :key="row[props.dataKey] ?? rowIndex"
            class="bg-white rounded-lg shadow-sm border border-gray-100 p-4 active:bg-gray-50 transition-colors"
            @click="onRowClick({ originalEvent: $event, data: row, index: rowIndex })"
            @dblclick="onRowDblClick({ originalEvent: $event, data: row, index: rowIndex })"
          >
            <div class="flex items-start justify-between gap-3">
              <div class="flex-1 min-w-0">
                <!-- Title -->
                <div class="font-semibold text-gray-900 text-sm truncate">
                  <slot :name="'body-' + mobileTitle.field" :data="row" :index="rowIndex">
                    {{ row[mobileTitle.field] }}
                  </slot>
                </div>
                <!-- Subtitle -->
                <div v-if="mobileSubtitle" class="text-xs text-gray-500 mt-0.5 truncate">
                  <slot :name="'body-' + mobileSubtitle.field" :data="row" :index="rowIndex">
                    {{ row[mobileSubtitle.field] }}
                  </slot>
                </div>
              </div>
              <!-- Action button -->
              <div v-if="actionsColumn" class="flex-shrink-0">
                <slot :name="'body-' + actionsColumn.field" :data="row" :index="rowIndex">
                  <i class="pi pi-ellipsis-v text-gray-400"></i>
                </slot>
              </div>
            </div>

            <!-- Detail fields (2-col grid) -->
            <div v-if="mobileDetails.length > 0" class="grid grid-cols-2 gap-x-4 gap-y-2 mt-3 pt-3 border-t border-gray-50">
              <div v-for="col in mobileDetails" :key="col.field" class="min-w-0">
                <div class="text-[10px] uppercase tracking-wider text-gray-400 mb-0.5">{{ col.header }}</div>
                <div class="text-xs text-gray-700 truncate">
                  <slot :name="'body-' + col.field" :data="row" :index="rowIndex">
                    {{ row[col.field] ?? '-' }}
                  </slot>
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile Pagination -->
          <div v-if="mobileTotalPages > 1" class="flex items-center justify-between pt-3 pb-1">
            <button
              class="px-3 py-2 text-xs font-medium rounded-md border border-gray-200 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 min-h-[44px]"
              :disabled="mobileCurrentPage <= 1"
              @click="mobileCurrentPage--"
            >
              <i class="pi pi-chevron-left mr-1"></i> Prev
            </button>
            <span class="text-xs text-gray-500">
              {{ mobileRangeStart }}-{{ mobileRangeEnd }} of {{ mobileFilteredTotal }}
            </span>
            <button
              class="px-3 py-2 text-xs font-medium rounded-md border border-gray-200 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 min-h-[44px]"
              :disabled="mobileCurrentPage >= mobileTotalPages"
              @click="mobileCurrentPage++"
            >
              Next <i class="pi pi-chevron-right ml-1"></i>
            </button>
          </div>
        </div>
      </template>
    </div>

    <!-- Desktop DataTable (hidden on mobile when card view is active) -->
    <template v-else>
      <!-- Desktop skeleton -->
      <MOPTableSkeleton v-if="props.loading" :columns="props.columns" />

      <DataTable
        v-else
        ref="dataTableRef"
        v-bind="$attrs"
        :value="props.value"
        :dataKey="props.dataKey"
        :rows="shouldShowPagination ? props.rows : totalDataCount"
        :totalRecords="props.totalRecords"
        :paginator="shouldShowPagination"
        :paginatorPosition="props.paginatorPosition"
        :pageSizeOptions="props.pageSizeOptions"
        :selectionMode="props.selectionMode"
        :selection="props.selection"
        :sortable="props.sortable"
        :sortField="props.sortField"
        :sortOrder="props.sortOrder"
        :multiSort="props.multiSort"
        v-model:filters="filters"
        :loading="false"
        :rowHover="props.rowHover"
        :showGridlines="props.showGridlines"
        :stripedRows="props.stripedRows"
        :scrollable="props.scrollable"
        :resizable="props.resizable"
        :resizableColumns="!!props.resizableColumns"
        :class="tableClasses"
        filterDisplay="menu"
        @selection-change="onSelectionChange"
        @page="onPage"
        @sort="onSort"
        @filter="onFilter"
        @row-click="onRowClick"
        @row-dblclick="onRowDblClick"
      >
        <!-- Dynamic Columns -->
        <Column v-for="col in props.columns"
               :key="col.field"
               :field="col.field"
               :header="col.header"
               :sortable="col.sortable"
               :filterable="col.filterable"
               :alignFrozen="col.alignFrozen"
               :frozen ="col.frozen"
               :bodyClass="col.bodyClass"
               :hidden="col.hidden">
          <template #filter="{ filterModel }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter-element"
              :placeholder="`Search by ${col.header.toLowerCase()}`"
              @input="applyColumnFilter(col.field)"
            />
          </template>

          <template #body="slotProps">
            <slot :name="'body-' + col.field" v-bind="slotProps">
              {{ slotProps.data[col.field] }}
            </slot>
          </template>
        </Column>
      </DataTable>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import type { DataTableFilterMeta, DataTablePageEvent, DataTableSortEvent } from 'primevue/datatable'
import type { MOPDataTableProps, MOPDataTableFilterEvent, MOPDataTableColumn } from './types'
import { useResponsive } from '@/composables/useResponsive'
import MOPCardSkeleton from '@/components/MOPLoader/MOPCardSkeleton.vue'
import MOPTableSkeleton from '@/components/MOPLoader/MOPTableSkeleton.vue'

defineOptions({
  name: 'MOPDataTable',
  inheritAttrs: false
})

const props = withDefaults(defineProps<MOPDataTableProps>(), {
  rows: 10,
  first: 0,
  totalRecords: 0,
  lazy: false,
  transactionStatus: 0,
    clearShow:  true,
  columns: () => [],
  paginator: false,
  paginatorPosition: 'bottom',
  pageSizeOptions: () => [10, 20, 30, 50],
  selectionMode: undefined,
  selection: undefined,
  sortable: false,
  sortField: undefined,
  sortOrder: undefined,
  multiSort: false,
  filterable: false,
  alignFrozen:  '',
  frozen:  false,
  bodyClass:  '',
  loading: false,
  rowHover: false,
  showGridlines: false,
  stripedRows: false,
  size: 'normal',
  scrollable: false,
  scrollHeight: undefined,
  resizable: false,
  resizableColumns: undefined,
  rtl: false,
  responsive: false,
  ariaLabel: 'Data Table',
  paginatorAriaLabel: 'Pagination',
  filterDisplay: undefined,
  globalFilterFields: () => [],
  showFilterMatchModes: true,
  filterMenuStyle: undefined,
  importStatus:  0,
  exportStatus:  0,
  importshow:  false,
  bulkimport: false,
  mobileCardView:  true,
  mobileBreakpoint: 768,
})

const emit = defineEmits([
  'update:selection',
  'selection-change',
  'update:first',
  'page',
  'update:sortField',
  'update:sortOrder',
  'sort',
  'update:filters',
  'filter',
  'row-click',
  'row-dblclick',
  'excel-data-import',
  'importclick'
])

// Responsive state
const { isMobile } = useResponsive()

const dataTableRef = ref()
const globalFilterValue = ref('')
const mobileCurrentPage = ref(1)

interface FilterMetaData {
  value: any
  matchMode: string
}
const fileInput: any = ref(null);

const triggerFileInput = () => {
  if (props.importStatus == 0) {
    emit('importclick')
  } else {
    if (fileInput.value) {
      fileInput.value.click();
    }
  }

};

// ===== MOBILE CARD VIEW LOGIC =====

const showMobileCards = computed(() => {
  return isMobile.value && props.mobileCardView
})

// Auto-detect mobile column layout from column definitions
const mobileTitle = computed<MOPDataTableColumn>(() => {
  if (props.mobileCardTitleField) {
    const col = props.columns.find(c => c.field === props.mobileCardTitleField)
    if (col) return col
  }
  // Find column with mobilePriority 1, or fall back to first non-action column
  const priorityCol = props.columns.find(c => c.mobilePriority === 1)
  if (priorityCol) return priorityCol
  const firstCol = props.columns.find(c => c.field !== 'actions' && c.mobileVisible !== false)
  return firstCol || props.columns[0]
})

const mobileSubtitle = computed<MOPDataTableColumn | null>(() => {
  if (props.mobileCardSubtitleField) {
    return props.columns.find(c => c.field === props.mobileCardSubtitleField) || null
  }
  const priorityCol = props.columns.find(c => c.mobilePriority === 2)
  if (priorityCol) return priorityCol
  // Fall back to second non-action column
  const nonActionCols = props.columns.filter(c => c.field !== 'actions' && c.mobileVisible !== false)
  return nonActionCols.length > 1 ? nonActionCols[1] : null
})

const actionsColumn = computed<MOPDataTableColumn | null>(() => {
  return props.columns.find(c => c.field === 'actions' || c.field === 'Actions') || null
})

const mobileDetails = computed<MOPDataTableColumn[]>(() => {
  // Get columns with mobilePriority 3, or auto-detect next 4 columns
  const priorityCols = props.columns
    .filter(c => c.mobilePriority === 3 && c.mobileVisible !== false)

  if (priorityCols.length > 0) return priorityCols.slice(0, 4)

  // Auto-detect: skip title, subtitle, actions, and hidden columns
  const titleField = mobileTitle.value?.field
  const subtitleField = mobileSubtitle.value?.field
  const actionsField = actionsColumn.value?.field

  return props.columns
    .filter(c =>
      c.field !== titleField &&
      c.field !== subtitleField &&
      c.field !== actionsField &&
      c.mobileVisible !== false &&
      c.mobilePriority !== 0 &&
      !c.hidden
    )
    .slice(0, 4)
})

// Mobile pagination
const mobileRowsPerPage = computed(() => props.rows || 10)

const mobileFilteredTotal = computed(() => {
  return props.totalRecords || props.value?.length || 0
})

const mobileTotalPages = computed(() => {
  return Math.ceil(mobileFilteredTotal.value / mobileRowsPerPage.value)
})

const mobilePagedData = computed(() => {
  if (!props.value) return []
  // If server-side pagination is used (totalRecords set and data is already paged), return as-is
  if (props.totalRecords && props.totalRecords > 0 && props.value.length <= mobileRowsPerPage.value) {
    return props.value
  }
  // Client-side pagination
  const start = (mobileCurrentPage.value - 1) * mobileRowsPerPage.value
  return props.value.slice(start, start + mobileRowsPerPage.value)
})

const mobileRangeStart = computed(() => {
  return (mobileCurrentPage.value - 1) * mobileRowsPerPage.value + 1
})

const mobileRangeEnd = computed(() => {
  return Math.min(mobileCurrentPage.value * mobileRowsPerPage.value, mobileFilteredTotal.value)
})

// ===== ORIGINAL TABLE LOGIC =====

const filters = ref<DataTableFilterMeta>({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS } as FilterMetaData,
  ...(props.columns || []).reduce((acc, col) => ({
    ...acc,
    [col.field]: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
    }
  }), {} as DataTableFilterMeta)
})

const clearFilter = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS } as FilterMetaData,
    ...(props.columns || []).reduce((acc, col) => ({
      ...acc,
      [col.field]: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
      }
    }), {} as DataTableFilterMeta)
  }
  globalFilterValue.value = ''
  emit('update:filters', filters.value)
}


// Debounce utility
function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function(this: any, ...args: Parameters<T>) {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

const onGlobalFilter = () => {
  const globalFilter = filters.value.global as FilterMetaData
  globalFilter.value = globalFilterValue.value
  emit('update:filters', filters.value)
}

// Debounced version for input
const debouncedOnGlobalFilter = debounce(onGlobalFilter, 300);

const clearColumnFilter = (field: string) => {
  if (filters.value[field]) {
    filters.value[field] = {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
    }
    emit('update:filters', filters.value)
  }
}

const applyColumnFilter = (field: string) => {
  emit('update:filters', filters.value)
  emit('filter', {
    filters: filters.value,
    field
  })
}

const onSelectionChange = (event: { value: any }) => {
  emit('update:selection', event.value)
  emit('selection-change', event.value)
}

// const onPage = (event: DataTablePageEvent) => {
//   emit('update:first', event.first)
//   emit('page', {
//     page: Math.floor(event.first / props.rows!),
//     first: event.first,
//     rows: event.rows,
//     pageCount: Math.ceil(props.totalRecords! / event.rows)
//   })
// }

const onPage = (event: DataTablePageEvent) => {
  emit('update:first', event.first)

  emit('page', {
    page: Math.floor(event.first / event.rows) + 1, // ✅ correct
    first: event.first,
    rows: event.rows,
    pageCount: Math.ceil(props.totalRecords! / event.rows)
  })
}

const onSort = (event: DataTableSortEvent) => {
  const { sortField, sortOrder } = event
  emit('update:sortField', sortField)
  emit('update:sortOrder', sortOrder)
  emit('sort', { sortField, sortOrder })
}

const onFilter = (event: MOPDataTableFilterEvent) => {
  emit('update:filters', event.filters)
  emit('filter', event)
}

const onRowClick = (event: { originalEvent: Event; data: Record<string, unknown>; index: number }) => {
  emit('row-click', event)
}

const onRowDblClick = (event: { originalEvent: Event; data: Record<string, unknown>; index: number }) => {
  emit('row-dblclick', event)
}
const handleFileUpload = async (event: Event) => {
  const input = event.target as HTMLInputElement;
  const file = input.files ? input.files[0] : null;
  if (file) {
    try {
      // Read the Excel file
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = e.target?.result;
          // Import xlsx dynamically
          const XLSX = await import('xlsx');

          // Parse the Excel data
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          console.log("Excel data parsed successfully", jsonData);

          // Emit the parsed data to the parent component
          emit("excel-data-import", jsonData);

          // Reset the file input
          if (fileInput.value) {
            fileInput.value.value = '';
          }
        } catch (error) {
          console.error("Error parsing Excel file", error);
        }
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Error uploading file", error);
    }
  }
};
// Computed property to determine if pagination should be shown
const shouldShowPagination = computed(() => {
  if (!props.paginator) return false
  const dataLength = props.value?.length || 0
  return dataLength >= (props.rows || 10)
})

// Computed property to get total data count for non-paginated view
const totalDataCount = computed(() => {
  return props.value?.length || 0
})

const tableClasses = computed(() => [
  'p-datatable p-component',
  {
    'p-datatable-hoverable-rows': props.rowHover,
    'p-datatable-auto-layout': !props.scrollable,
    'p-datatable-resizable': props.resizable,
    'p-datatable-resizable-fit': props.resizableColumns === 'fit',
    'p-datatable-striped': props.stripedRows,
    'p-datatable-gridlines': props.showGridlines,
    'p-datatable-rtl': props.rtl,
    'p-datatable-responsive': props.responsive,
    [`p-datatable-${props.size}`]: props.size !== 'normal'
  }
])

const menu = ref()
const items = ref([
  {
    label: 'Export',
    items: [
      {
        label: 'PDF',
        icon: 'pi pi-file-pdf',
        command: () => exportToPDF()
      },
      {
        label: 'Excel',
        icon: 'pi pi-file-excel',
        command: () => exportToExcel()
      },
    ]
  }
])
const toggle = (event: Event) => {
  menu.value.toggle(event)
}
//
// Helper function to get base64 image
const getBase64Image = async (imgPath: string): Promise<string> => {
  return new Promise((resolve) => {
    try {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onerror = () => {
        console.error('Error loading image:', imgPath);
        resolve('');
      };
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } else {
          console.error('Could not get canvas context');
          resolve('');
        }
      };
      img.src = imgPath;
    } catch (error) {
      console.error('Error in getBase64Image:', error);
      resolve('');
    }
  });
};

const exportToPDF = async () => {
  try {
    // Dynamically import required libraries
    const { default: jsPDF } = await import('jspdf');
    const { default: autoTable } = await import('jspdf-autotable');

    // Get data from the table
    const rawData = props.value || [];

    if (rawData.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Get column definitions
    // const columns = props.exportcolumns || [];
    const columns = props.transactionStatus == 0 ? props.columns : props.exportcolumns || [];

    // Filter out Action and Status columns
    const filteredColumns = columns.filter(col => {
      const headerLower = col.header.toLowerCase();
      return !headerLower.includes('action') &&
        !headerLower.includes('status') &&
        !headerLower.includes('active') &&
        !headerLower.includes('inactive');
    });

    // Create PDF document
    const pdf = new jsPDF('l', 'mm', 'a4'); // landscape orientation for better table fit

    // Prepare headers and data for autotable
    const headers = filteredColumns.map(col => col.header);
    const data = rawData.map(row =>
      filteredColumns.map(col => String(row[col.field] || ''))
    );

    // Get logo as base64
    const logoPath = '/src/assets/Img/Logo/MoceroFooterLogo.png';
    const logoBase64 = await getBase64Image(logoPath);

    // Add logo and header information
    const title = 'Data Export';
    const headerInfo = {
      hospitalName: 'Mocero Hospital',
      contactInfo: '+91 1234567890',
      address: 'Mocero Hospital, 123 Main Street, City - 123456'
    };
    const footerInfo = {
      hospitalName: 'Mocero Hospital',
      contactInfo: '+91 1234567890'
    };

    const pageWidth = pdf.internal.pageSize.width;
    const headerY = 10;
    const headerLogoWidth = 45;
    const headerLogoHeight = 18;
    const headerPadding = 14;

    // Add logo to header
    if (logoBase64) {
      pdf.addImage(logoBase64, 'PNG', headerPadding, headerY, headerLogoWidth, headerLogoHeight);
    }

    // Add header with hospital info
    pdf.setFontSize(16);
    pdf.text(headerInfo.hospitalName, pageWidth / 2, headerY + 8, { align: 'center' });
    pdf.setFontSize(10);
    pdf.text(headerInfo.address, pageWidth / 2, headerY + 14, { align: 'center' });
    pdf.text(headerInfo.contactInfo, pageWidth / 2, headerY + 20, { align: 'center' });

    // Add title
    pdf.setFontSize(14);
    pdf.text(title, pageWidth / 2, headerY + 30, { align: 'center' });

    // Add table to PDF with adjusted margins to account for header
    autoTable(pdf, {
      head: [headers],
      body: data as any[][],
      theme: 'grid',
      headStyles: { fillColor: [66, 139, 202], textColor: 255 },
      margin: { top: 50 }, // Increased top margin to accommodate header and logo
      styles: { overflow: 'linebreak', cellWidth: 'auto' },
      columnStyles: { text: { cellWidth: 'auto' } },
      didDrawPage: (data) => {
        // Add footer on each page
        const pageSize = pdf.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        const footerY = pageHeight - 15;
        const footerLogoWidth = 35;
        const footerLogoHeight = 10;
        const footerPadding = 10;

        // Add line above footer
        pdf.setDrawColor(200, 200, 200);
        pdf.line(footerPadding, footerY, pageWidth - footerPadding, footerY);

        // Add logo to footer
        if (logoBase64) {
          pdf.addImage(logoBase64, 'PNG', (pageWidth - footerLogoWidth) / 2, footerY + 2, footerLogoWidth, footerLogoHeight);
        }

        pdf.setFontSize(9);
        pdf.text(footerInfo.hospitalName, footerPadding, footerY + 8);
        pdf.text(footerInfo.contactInfo, pageWidth - footerPadding, footerY + 8, { align: 'right' });

        // Add page number
        pdf.text(`Page ${data.pageNumber} of ${pdf.getNumberOfPages()}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: 'center' });
      }
    });

    // Save the PDF
    pdf.save('table-export.pdf');
  } catch (error) {
    console.error('Error exporting to PDF:', error);
  }
}

const exportToExcel = () => {
  try {
    // Get data from the table
    const rawData = props.value || [];

    if (rawData.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Get column definitions
    const columns = props.transactionStatus == 0 ? props.columns : props.exportcolumns || [];

    // Filter out Action and Status columns
    const filteredColumns = columns.filter(col => {
      const headerLower = col.header.toLowerCase();
      return !headerLower.includes('action') &&
        !headerLower.includes('status') &&
        !headerLower.includes('active') &&
        !headerLower.includes('inactive');
    });

    // Format data to match headers, excluding Action and Status fields
    const formattedData = rawData.map(row => {
      const formattedRow: Record<string, any> = {};
      filteredColumns.forEach(col => {
        // Use header as the key and field value as the value
        formattedRow[col.header] = row[col.field];
      });
      return formattedRow;
    });

    // Dynamically import xlsx
    import('xlsx').then((XLSX) => {
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, 'table-export.xlsx');
    });
  } catch (error) {
    console.error('Error exporting to Excel:', error);
  }
}

const exportToCSV = () => {

}

</script>

<style scoped>
/* Thicker (medium) scrollbars on the table scroll container.
   Applies to both horizontal and vertical scrollbars. */
:deep(.p-datatable-wrapper),
:deep(.p-datatable-scrollable-wrapper),
:deep(.p-datatable-scrollable-body),
:deep(.p-datatable-table-container) {
  scrollbar-width: auto;              /* Firefox: default (thicker) */
  scrollbar-color: #94a3b8 #f1f5f9;   /* Firefox: thumb / track */
}

:deep(.p-datatable-wrapper::-webkit-scrollbar),
:deep(.p-datatable-scrollable-wrapper::-webkit-scrollbar),
:deep(.p-datatable-scrollable-body::-webkit-scrollbar),
:deep(.p-datatable-table-container::-webkit-scrollbar) {
  height: 12px;
  width: 12px;
}

:deep(.p-datatable-wrapper::-webkit-scrollbar-track),
:deep(.p-datatable-scrollable-wrapper::-webkit-scrollbar-track),
:deep(.p-datatable-scrollable-body::-webkit-scrollbar-track),
:deep(.p-datatable-table-container::-webkit-scrollbar-track) {
  background: #f1f5f9;
  border-radius: 6px;
}

:deep(.p-datatable-wrapper::-webkit-scrollbar-thumb),
:deep(.p-datatable-scrollable-wrapper::-webkit-scrollbar-thumb),
:deep(.p-datatable-scrollable-body::-webkit-scrollbar-thumb),
:deep(.p-datatable-table-container::-webkit-scrollbar-thumb) {
  background: #94a3b8;
  border-radius: 6px;
  border: 2px solid #f1f5f9;          /* inset look, keeps thumb visually ~8px */
}

:deep(.p-datatable-wrapper::-webkit-scrollbar-thumb:hover),
:deep(.p-datatable-scrollable-wrapper::-webkit-scrollbar-thumb:hover),
:deep(.p-datatable-scrollable-body::-webkit-scrollbar-thumb:hover),
:deep(.p-datatable-table-container::-webkit-scrollbar-thumb:hover) {
  background: #64748b;
}
</style>
